import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import DateFilter, {keys as DATE_FILTER_KEYS} from '@stubhub/react-date-filter';
import GeoFilter from '@stubhub/react-geo-filter';

import '../styles/index.scss';

const SMALL_WIDTH_BREAKPOINT = 640;

const FEATURE_FLAGS = {
  SEARCHPAGE_ENABLE_DATE_FILTER: 'searchpage.enableDateFilter',
  HOMEPAGE_ENABLE_DATE_FILTER: 'homepage.hub.enableDateFilter',
  PERFORMER_ENABLE_DATE_FILTER: 'performer.enableDateFilter',
};

const NavFilter = ({
  className,
  globalRegistry,
  screenSize = 'small',
  homepage,
  searchpage,
  categorypage,
  performerpage,
  geographypage,
  venuepage,
  langSelector,
  noDateSelector,
  start,
  end,
}) => {
  const isSmall = __CLIENT__ ? window.innerWidth < SMALL_WIDTH_BREAKPOINT : true;

  const homepageDateFilter = homepage || langSelector;

  const searchpageDateFilter =
    searchpage && globalRegistry?.getFeatureValue(FEATURE_FLAGS.SEARCHPAGE_ENABLE_DATE_FILTER);

  const categorypageDateFilter =
    categorypage && globalRegistry?.getFeatureValue(FEATURE_FLAGS.HOMEPAGE_ENABLE_DATE_FILTER);

  const performerpageDateFilter =
    performerpage && globalRegistry?.getFeatureValue(FEATURE_FLAGS.PERFORMER_ENABLE_DATE_FILTER);

  const withDateFilter = !!(
    (homepageDateFilter && !noDateSelector) ||
    searchpageDateFilter ||
    categorypageDateFilter ||
    performerpageDateFilter
  );

  const withGeoFilter = homepage || categorypage || searchpage || geographypage || venuepage;

  const geoFilterProps = {
    className: cs({'with-geo-filter': withDateFilter}, 'merch-geo-filter'),
  };
  if (screenSize !== 'small') {
    geoFilterProps.dropdownAlign = 'right';
  }
  const dateFilterProps = {
    start,
    end,
    selected: DATE_FILTER_KEYS.K_ALL,
    inPillBar: true,
    useAltMsgs: true,
    dropDownToggle: true,
    draggable: isSmall,
    useBackdrop: isSmall,
  };

  if (homepageDateFilter) {
    geoFilterProps.homepageDateFilter = homepageDateFilter;
    dateFilterProps.homepage = homepage;
  }
  if (searchpageDateFilter) {
    geoFilterProps.searchpageDateFilter = searchpageDateFilter;
    dateFilterProps.searchpage = searchpage;
  }

  const containerClassName = cs(
    'NavFilter',
    {dual: withDateFilter},
    {langSelector},
    {compact: screenSize !== 'small'},
    className
  );

  return (
    <div className={containerClassName}>
      {withGeoFilter && <GeoFilter {...geoFilterProps} />}
      {withDateFilter && (
        <>
          <div className="line" />
          <DateFilter {...dateFilterProps} />
        </>
      )}
    </div>
  );
};

NavFilter.propTypes = {
  /* The optional className */
  className: PropTypes.string,

  /* The screen size */
  screenSize: PropTypes.string,

  /* The globalRegistry object */
  globalRegistry: PropTypes.object,

  /* the start date*/
  start: PropTypes.string,

  /* the end date*/
  end: PropTypes.string,

  /* whether it is homepage */
  homepage: PropTypes.bool,

  /* whether it is search page */
  searchpage: PropTypes.bool,

  /* whether it is category page */
  categorypage: PropTypes.bool,

  /* whether it is performer page */
  performerpage: PropTypes.bool,

  /* whether it is geography page */
  geographypage: PropTypes.bool,

  /* whether it is venue page */
  venuepage: PropTypes.bool,

  /* if lang selector should be shown */
  langSelector: PropTypes.bool,

  /* wether to show date selector */
  noDateSelector: PropTypes.bool,
};

export default NavFilter;
